module.exports = __webpack_public_path__ + "static/media/logo.5a4cd0e6.png";